import { render, staticRenderFns } from "./PartnerPremiumBanner.vue?vue&type=template&id=3e479464&scoped=true"
import script from "./PartnerPremiumBanner.vue?vue&type=script&lang=ts"
export * from "./PartnerPremiumBanner.vue?vue&type=script&lang=ts"
import style0 from "./PartnerPremiumBanner.vue?vue&type=style&index=0&id=3e479464&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e479464",
  null
  
)

export default component.exports